export default __webpack_public_path__ + "static/media/drag.9d39e504.svg";